<template>
    <div class="w-full surface-100">
		<div class="center xl:pt-0 xl:pb-8 lg:pt-0 xl:pb-7 md:pt-0 md:pb-6">
			<div class="flex flex-column pt-6 xl:pt-8 justify-content-center align-items-center text-center">

				<div class="hidden xl:flex text-900 font-semibold mb-5 text-3xl xl:text-6xl lg:text-5xl md:text-4xl sm:text-3xl">
					{{ content[lang_].title }}
				</div>

				<div class="flex xl:hidden text-900 font-semibold mb-5 text-5xl xl:text-6xl lg:text-5xl md:text-4xl sm:text-3xl">
					{{ content[lang_].title_short }}
				</div>

				<div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
					px-3 pb-2 xl:pb-5 lg:pb-3" >

					<div class="w-full flex 
						flex-row xl:flex-row lg:flex-row md:flex-row lg:flex-row 
						gap-2 xl:gap-5 lg:gap-3
						xl:pr-3 lg:pr-2 md:pr-1
						pb-2 xl:pb-0 lg:pb-0 md:pb-0">

						<div class="w-full flex 
							flex-column xl:flex-column lg:flex-column md:flex-column 
							gap-2 xl:gap-5 lg:gap-3">
							
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem 
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="text-700 text-md xl:text-xl">
									{{ content.advantages[0][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_percent.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[1][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_first.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

						</div>
 
						<div class="w-full flex flex-column">
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								h-12rem xl:h-24rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl line-height-1 
									w-8 xl:w-full lg:w-full md:w-full">
									{{ content.advantages[2][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_receive.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>
						</div>
						
					</div>
					
					<div class="w-full flex 
						flex-row xl:flex-column lg:flex-column md:flex-column
						gap-2 xl:gap-5 lg:gap-3
						xl:pl-3 lg:pl-2 md:pl-1">

						<div class="w-full flex flex-column xl:flex-row lg:flex-row">
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl line-height-1 w-6">
									{{ content.advantages[5][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_phone.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>
						</div>

						<div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
							gap-2 xl:gap-5 lg:gap-3">

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[3][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_time.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[4][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_cryp.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

						</div>
						
					</div>
				</div>

				<div v-if="!more" class="w-full flex justify-content-center mt-4">
                    <Button :label="content[lang_].button" class="flex px-5 surface-0 border-round-lg" variant="text" severity="info" @click="show_more()" />
                </div> 


				<div v-if="more" class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
					px-3" >

					<div class="w-full flex 
						flex-row xl:flex-column lg:flex-column md:flex-column
						gap-2 xl:gap-5 lg:gap-3
						xl:pr-3 lg:pr-2 md:pr-1
						mb-2 xl:mb-0 lg:mb-0 md:mb-0 ">

						<div class="w-full flex flex-column xl:flex-row lg:flex-row">
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl line-height-1 w-6">
									{{ content.advantages[6][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_rp.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>
						</div>

						<div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row 
							gap-2 xl:gap-5 lg:gap-3">

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[7][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_chat.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[8][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_third.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

						</div>
						
					</div>

					<div class="w-full flex 
						flex-row xl:flex-row lg:flex-row md:flex-row lg:flex-row 
						gap-2 xl:gap-5 lg:gap-3
						xl:pl-3 lg:pl-2 md:pl-1
						pb-2 xl:pb-0 lg:pb-0 md:pb-0">

						<div class="w-full flex flex-column">
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								h-12rem xl:h-24rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl line-height-1 
									w-8 xl:w-full lg:w-full md:w-full">
									{{ content.advantages[9][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_receive.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>
						</div>

						<div class="w-full flex 
							flex-column xl:flex-column lg:flex-column md:flex-column 
							gap-2 xl:gap-5 lg:gap-3">
							
							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem 
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="text-700 text-md xl:text-xl">
									{{ content.advantages[10][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_group.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

							<div class="w-full flex flex-column surface-0 flex-1 
								relative
								p-3 xl:p-4 lg:p-4 md:p-4
								xl:h-12rem lg:h-10rem md:h-8rem
								border-round-xl xl:border-round-2xl 
								text-left">
								<span class="flex text-700 text-md xl:text-xl mb-2">
									{{ content.advantages[11][lang_] }}
								</span>
								<img src="/images/svg/icons/ad_first.svg" class="absolute bottom-0 right-0 
									w-1rem xl:w-auto lg:w-auto md:w-auto
									m-2 xl:m-3">
							</div>

						</div>
						
					</div>
					
				</div>

			</div>
		</div>
	</div>
</template>

<script>
    export default {
        data(){
            return{
                content: {
					ru: {
						title: 'Преимущества PayWave',
						title_short: 'Преимущества',
						button: 'Все преимущества',
					},
					en: {
						title: 'PayWave advantages',
						title_short: 'Advantages',
						button: 'All advantages',
					},
					advantages: [
						{
							ru: 'Комиссия от 3% на любую сумму',
							en: 'Commission 3% for any amount',
						},
						{
							ru: 'Первый перевод от 500 рублей',
							en: 'First transfer from 500 rubles',
						},
						{
							ru: 'Принимаем оплату с любых подсанкционных банков России. А также с любых банков стран Азии',
							en: 'We accept payment from any sub-sanctioned banks in Russia. As well as from any banks in Asian countries',
						},
						{
							ru: 'Быстрый перевод всего от 5 минут',
							en: 'Fast transfer in just 5 minutes',
						},
						{
							ru: 'Без покупки-продажи криптовалюты',
							en: 'No purchase or sale of cryptocurrencies',
						},
						{
							ru: 'Легкий и удобный интерфейс',
							en: 'Easy and convenient interface',
						},
						{
							ru: 'Снятие наличных в банкомате без карты',
							en: 'Cash withdrawal at an ATM without a card',
						},
						{
							ru: 'Поддержка 24/7',
							en: 'Support 24/7',
						},
						{
							ru: 'Возможность перевода третьим лицам',
							en: 'Ability to transfer to third parties',
						},
						{
							ru: 'Пополнение кошельков Gojek, OVO, Dana',
							en: 'Top up Gojek, OVO, Dana wallets',
						},
						{
							ru: 'Партнерская программа',
							en: 'Affiliate program',
						},
						{
							ru: 'Покупка авиа-билетов и отелей',
							en: 'Purchase of air tickets and hotels',
						}
					]
				},
				more: false,
            }
        },
		methods: {
			show_more(){
				this.more = !this.more
			}
        },
		computed: {
			lang_() {
				return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
			},  
		},
    }
</script>